import type { YesNo } from '../types';

type GetDeliveryMethodAvailabilityParams = {
    availablePurchaseOptions: Maybe<{ oneTime: boolean; autoship: boolean }>;
    purchaseOption: 'one-time' | 'autoship';
};

export const getDeliveryMethodAvailability = ({
    availablePurchaseOptions,
    purchaseOption,
}: GetDeliveryMethodAvailabilityParams): YesNo => {
    const key = purchaseOption === 'autoship' ? 'autoship' : 'oneTime';
    return availablePurchaseOptions?.[key] ? 'yes' : 'no';
};
